export default "__VITE_ASSET__783fcb8b__"